module.exports = __webpack_public_path__ + "media/images/img/recruitinfo-d7f429b0a6c6623a6e16df8ad7e5ee8f.jpg";